export default (function(arr) {
  arr.forEach(item => {
    if (!item.hasOwnProperty('append')) {
      Object.defineProperty(item, 'append', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append(...args: HTMLElement[]) {
          const argArr = args.slice()
          const docFrag = document.createDocumentFragment()

          argArr.forEach(function(argItem) {
            const isNode = argItem instanceof Node
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)))
          })

          this.appendChild(docFrag)
        },
      })
    }
    if (!item.hasOwnProperty('remove')) {
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this)
        },
      })
    }
  })
})([Element.prototype, Document.prototype, DocumentFragment.prototype])

Promise.allSettled =
  Promise.allSettled ||
  ((promises: Promise<unknown>[]) =>
    Promise.all(
      promises.map(p =>
        p
          .then(value => ({
            status: 'fulfilled',
            value,
          }))
          .catch(reason => ({
            status: 'rejected',
            reason,
          }))
      )
    ))

// Guard `@starlight/popover`'s show/hide calls against disconnected elements:
// when a modal closes the popover element is orphaned with the dialog, and the
// library's reparenting effect early-returns on `!isConnected`.
;(function patchPopoverApi() {
  if (typeof HTMLElement === 'undefined') return
  const proto = (HTMLElement.prototype as unknown) as {
    showPopover?: () => void
    hidePopover?: () => void
  }

  const callOrSwallow = (el: HTMLElement, original: () => void): void => {
    try {
      original.call(el)
    } catch (err) {
      if (err instanceof DOMException && err.name === 'InvalidStateError') return
      throw err
    }
  }

  const originalShow = proto.showPopover
  if (typeof originalShow === 'function') {
    Object.defineProperty(proto, 'showPopover', {
      configurable: true,
      writable: true,
      value: function patchedShowPopover(this: HTMLElement) {
        if (!this.isConnected) {
          try {
            document.body.appendChild(this)
          } catch {
            return
          }
        }
        callOrSwallow(this, originalShow)
      },
    })
  }

  const originalHide = proto.hidePopover
  if (typeof originalHide === 'function') {
    Object.defineProperty(proto, 'hidePopover', {
      configurable: true,
      writable: true,
      value: function patchedHidePopover(this: HTMLElement) {
        if (!this.isConnected) return
        callOrSwallow(this, originalHide)
      },
    })
  }
})()
